import { announcementsStore } from '@common/stores/announcementStore'
import { signInModalStore } from '@common/stores/signInModalStore'
import { createContext, useMemo } from 'react'

const appStores = {
    announcementsStore,
    signInModalStore,
}
export const StoreContext = createContext(appStores)

// Combined Provider
export const StoreProvider = ({ children }) => {
    const value = useMemo(() => appStores, [])
    return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
}
